import { DesignedIcon, Rule } from "@with-nx/simple-ui/atoms";
import { ReactNode, useEffect } from "react";
import { Box } from "simple-effing-primitive-layout";
import { useFileUpload } from "@with-nx/ecommerce";

import Area from "./area";
import AwsArea from "./aws-area";

export type CustomBlob = { id: number; signed_id: string };

interface FileCardProps {
  change?: (blob?: CustomBlob) => void;
  height?: number;
  bottom?: number;
}

export const AWSFileCard = ({
  change,
  height = 40,
  bottom = 24,
}: FileCardProps) => {
  const {
    file,
    blob,
    uploading,
    uploadProgress,
    inputRef,
    handleClickChoose,
    handleFileChosen,
  } = useFileUpload();

  useEffect(() => {
    change?.(blob);
  }, [blob]);

  return !file ? (
    <AwsArea
      height={height}
      uploading={uploading}
      choose={(file) => handleFileChosen(file)}
      click={handleClickChoose}
      inputRef={inputRef}
    />
  ) : (
    <Box bottom={bottom}>
      <Box parse="d:flex a:flex-start">
        <Box
          parse="mnw:40 w:40 h:40 br:10 c:#333b47 d:inline-flex a:center j:center mr:12"
          style={{ minWidth: 40 }}
        >
          <DesignedIcon name="@paperclip" />
        </Box>
        <Box parse="d:flex fd:column j:center h:40">
          <Box parse="d:flex a:center">
            <Rule rule="ls" color="#AFAFAF" right={12}>
              {file?.name && file.name.length > 32
                ? file.name.substring(0, 32) + "..."
                : file.name}
            </Rule>
          </Box>
          <Box parse="d:flex a:center">
            <Rule rule="ls" color="#039420ff" right={12}>
              {`${uploadProgress.toFixed(1)}%`}
            </Rule>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AWSFileCard;
